import React from 'react';
import { Loader, TableFilter, BaasicModal, BaasicTable, BaasicConfirmModal, BaasicHeader } from 'core/components';
import { ReturnAddressEdit } from 'modules/return-address/pages';
import { defaultTemplate } from 'core/hoc';

const ReturnAddressListTemplate = ({
	t,
	viewStore,
	viewStore: {
		listStore,
		tableData,
		queryUtility,
		columnFilterSetup,
		editModal,
	},
	headerCell,
	actions,
	showActions,
}) => {
	if (viewStore.loading) return <Loader />;
	return (
		<section className="layout__main__body">
			<BaasicHeader title="MAINMENU.ADMINISTRATION.RETURNADDRESS"></BaasicHeader>
			<BaasicTable
				{...{
					listStore,
					tableData,
					queryUtility,
					viewStore,
					headerCell,
					actions,
					showActions,
				}}
				data={listStore.data.slice()}
			/>
			<TableFilter viewStore={viewStore} columnFilterSetup={columnFilterSetup} />
			<BaasicConfirmModal modalParams={viewStore.deleteConfirmModal} />
			<BaasicModal modalParams={editModal}>
				<ReturnAddressEdit parentViewStore={viewStore} />
			</BaasicModal>
		</section>
	);
};

export default defaultTemplate(ReturnAddressListTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/return-address/pages/ReturnAddressListTemplate.jsx